<template>
  <div class='resultsView'>
    <div v-if='selectedMetricCategory !== null && selectedCommunitiesCount !== 0'>
      <h4 class="center-align">{{ selectedMetricCategory.display }} for Selected Communities</h4>
      <div class="sticky_div_table">
        <div class="metricname_column">
          <div class="metric_label_header">Metric Name</div>
          <div class="metric_label valign-wrapper" v-for='metricLabel in currentMetricLabels'>{{ metricLabel.display_name }}</div>
        </div>
        <div class="result_rows_container">
          <div class="rows">
            <div class="headers">
              <div v-for='community in selectedCommunities' v-if='community.name in communityMetrics'>{{ community.name }}<i class='material-icons contribute-icon' title="Contribute Data" @click='contributeDataClick(community)'>add_circle_outline</i></div>
            </div>
            <div class="content-row" v-for='metricLabel in currentMetricLabels'>
              <div class="center-align" style="cursor: pointer;" @click='indicatorClick(metricLabel, community, communityMetrics[community.name][selectedMetricCategory.name][metricLabel.name])' title='Click for Details' v-for='community in selectedCommunities' v-if='community.name in communityMetrics'>
                <data-availability-indicator :score='communityMetrics[community.name][selectedMetricCategory.name][metricLabel.name].score'></data-availability-indicator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <h5 class="center-align">Select one or more communities above to view metrics</h5>
    </div>
    <div v-show='pendingCommunities' class='results-overlay center-align'>
      <h3>Loading Additional Communities</h3>
      <div class='preloader-wrapper big active'>
        <div class='spinner-layer spinner-blue-only'>
          <div class='circle-clipper left'>
            <div class='circle'></div>
          </div><div class='gap-patch'>
            <div class='circle'></div>
          </div><div class='circle-clipper right'>
            <div class='circle'></div>
          </div>
        </div>
      </div>
    </div>
    <div id='metadata-modal' class='modal bottom-sheet'>
      <div class='modal-content' v-if='metadataCommunity != null'>
        <h4>{{ metadataMetric.display_name }}</h4>
        <p>Data Resolution: {{ metadataMetric.data_temporality }}</p>
        <p>Data Availability Range: {{ metadataCommunityMetric.data_availability_range }}</p>
        <p>Data Format: {{ metadataMetric.available_formats }}</p>
        <p>View data set filtered for <a target="_blank" :href="metadataCommunityMetric.dataset_link">{{ metadataCommunity.name }}</a></p>
      </div>
    </div>
    <div id='contribute-data-modal' class='modal'>
      <div class='modal-content' v-if='contributeCommunity != null'>
        <h4>Contribute Data for {{ contributeCommunity.name }}</h4>
        <p>Thank you for your interest in contributing data to the Alaska Energy Data Gateway. Please select any of the datasets
        listed below that you'd like to contribute data towards, or select other and provide some details about your data.</p>
        <p>An administrator will contact you about your data.</p>
        <ul id="contribute-data-metric-list" v-for='(metricLabel, index) in currentMetricLabels'>
          <input :id="'metric_' + selectedMetricCategory.name + '_' + metricLabel.name" type='checkbox' class='filled-in'><label :for="'metric_' + selectedMetricCategory.name + '_' + metricLabel.name">{{ metricLabel.display_name }}</label>
        </ul>
        <textarea class="materialize-textarea" id="otherData" name="other_data_details" placeholder="Please describe any other data you'd like to contribue." />
        <input id='contributeName' placeholder="Your Name..." />
        <input id='contributeEmail' placeholder="Your email..."/>

        <p class="red-text" v-if="contributeError">{{ contributeErrorText }}</p>
      </div>
      <div class='modal-footer'>
        <button @click="submitContribute" class='btn waves-effect blue darken-4 left'>Submit</button>
        <button href='#!' class='btn modal-action modal-close waves-effect red'>Cancel</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import DataAvailabilityIndicator from './DataAvailabilityIndicator.vue'
import MetricModal from './MetricModal.vue'
import Materialize from 'Materialize'
var jQuery = require('jquery')

export default {
  name: 'results-list',
  data: function () {
    return {
      metadataCommunity: null,
      metadataMetric: null,
      metadataCommunityMetric: null,
      contributeCommunity: null,
      contributeError: false,
      contributeErrorText: ''
    }
  },
  computed: {
    ...mapState([
      'selectedMetricCategory',
      'communityList',
      'communityMetrics',
      'metrics'
    ]),
    ...mapGetters([
      'selectedCommunitiesCount',
      'selectedCommunities',
      'currentMetricLabels',
      'pendingCommunities',
      'communityBy'
    ])
  },
  mounted: function () {
    jQuery('#metadata-modal').modal()
    jQuery('#contribute-data-modal').modal()
  },
  methods: {
    indicatorClick: function (metric, community, communityMetric) {
      this.metadataCommunity = community
      this.metadataMetric = metric
      this.metadataCommunityMetric = communityMetric
      jQuery('#metadata-modal').modal('open')
    },
    contributeDataClick: function (community) {
      this.contributeCommunity = community
      jQuery('#contribute-data-modal').modal('open')
    },
    submitContribute: function () {
      // Get contents of the form in the modal
      let metricNames = jQuery.map(
        jQuery('#contribute-data-modal input:checkbox:checked'),
        function (item, i) {
          return item.id.split('_')[2]
      })

      let name = jQuery('#contributeName').val()
      let email = jQuery('#contributeEmail').val()
      let other = jQuery('#otherData').val()
      let form_data = {
        metrics: JSON.stringify(metricNames),
        name: name,
        community: this.contributeCommunity.name,
        email: email,
        other: other
      }

      jQuery.ajax({
        "dataType": 'json',
        "type": "POST",
        "url": "/community_metric_explorer/data_submission/",
        "data": form_data,
        "success": this.handleContributeResponse,
        "fail": this.handleContributeError
      })
    },
    handleContributeError: function () {
      this.contributeError = true
      this.contributeErrorText = 'A server error was encountered. Please try again later.'
      Materialize.toast('There was an error during your submission.', 5000)
    },
    handleContributeResponse: function (data) {
      if (data.send_error) {
        this.contributeError = data.send_error
        this.contributeErrorText = data.error_message
        Materialize.toast('There was an error during your submission.', 5000)
      } else {
        Materialize.toast('Thanks for your submission!', 5000)
        jQuery('#contribute-data-modal').modal('close')
        jQuery('#contribute-data-modal input:checkbox').prop('checked', false)
        jQuery('#otherData').val('')
        this.contributeError = false
      }
    }
  },
  components: {
    DataAvailabilityIndicator,
    MetricModal
  }
}
</script>
<style>

  .resultsView {
    position: relative;
  }

  .results-overlay {
    position: absolute;
    background-color: lightblue;
    border-radius: 10px;
    top: 20%;
    left: 20%;
    margin-left: auto;
    margin-right: auto;
  }

  .results-table thead th {
    white-space: nowrap;
  }

  .contribute-icon {
    vertical-align: bottom;
    cursor: pointer;
  }

  /* Styles for the sticky table */

  .sticky_div_table {
    width: 100%;
  }

  .metricname_column {
    width: 30%;
    float: left;
  }

  .metricname_column > div {
    overflow-y: hidden;
  }

  .metric_label_header {
    height: 2em;
    display: table-cell;
    vertical-align: bottom;
    font-weight: bold;
  }

  .metricname_column > .metric_label {
    height: 4em;
  }

  .metric_label:nth-child(odd) {
    background-color: #f2f2f2;
  }

  .result_rows_container {
    width: 70%;
    overflow-x: scroll;
    float: left;
  }

  .rows {
    display: table;
    min-width: 100%;
  }

  .headers {
    white-space: nowrap;
    height: 2em;
  }

  .content-row {
    white-space: nowrap;
    height: 4em;
  }

  .headers > div {
    display: inline-block;
    font-weight: bold;
    text-align: center;
    white-space: normal;
  }

  .content-row > div {
    display: inline-block;
    text-align: center;
  }

  .content-row > div > svg {
    margin-top: 1.25em;
  }

  .rows > div > div {
    width: 12em;
  }

  .content-row:nth-child(odd) {
    background-color: #f2f2f2;
  }

</style>



// WEBPACK FOOTER //
// ResultsList.vue?a0448406